import { RemoteSignupAccountCognito } from 'infra/http/cognito/remote-signup-account-cognito'
import { SignupAccountService } from 'infra/services/signup-account-service'

export const makeSignupAccount = () => new SignupAccountService(new RemoteSignupAccountCognito())
